import { Injectable, inject, signal } from '@angular/core';
import { TransferMedium } from '../models/transfer-medium.model';
import { TransferMediumService } from '../services/transfer-medium.service';
import { MediumPricat } from 'src/app/shared/enums/medium-pricat.enum';


@Injectable({ providedIn: 'root' })
export class TransferMediumStore {
  private readonly transferMediumService = inject(TransferMediumService);

  // Signals (statt BehaviorSubject/Observable)
  readonly transferMediums = signal<TransferMedium[]>([]);

  /**
   * Lädt alle TransferMedia und aktualisiert den State.
   */
  loadTransferMediums(): void {
    this.transferMediumService.fetchTransferMediums().pipe(
    ).subscribe({
      next: list => this.transferMediums.set(list),
      error: (error) => {
            throw error;
          }
    });
  }

  /** Optional: manuelles Setzen/Resetten */
  set(items: TransferMedium[]) { this.transferMediums.set(items); }
  clear() {
    this.transferMediums.set([]);
  }




  /**
   * Gibt die aktuelle Liste der Länder zurück.
   */
  getCountriesSnapshot(): TransferMedium[] {
    return this.transferMediums();
  }

  isFtpOrSftp(id?: number): boolean {
    return this.isFtp(id) || this.isSFtp(id);
  }

  isAnyFtp(id?: number): boolean {
     return id === MediumPricat.SFTP || id === MediumPricat.FTP_S || id === MediumPricat.Exite_FTP_S;
  }

  isFtp(id?: number): boolean {
      return id === MediumPricat.FTP_S;
  }
  isSFtp(id?: number): boolean {
    return id === MediumPricat.SFTP;
}
isEdiFtp(id?: number): boolean {
      return id === MediumPricat.Exite_FTP_S;
  }
  getFtpAndSftpIds(): number[] {
      return this.transferMediums().filter(medium => medium.name.toUpperCase() === 'FTP' || medium?.name.toUpperCase() === 'SFTP').map(medium => medium.id);
  }

  getTransferMediumNameById(id: number): string {
      const medium = this.transferMediums().find(m => m.id === id);
      return medium?.name || "Unbekannt";
  }

  
}